import styles from "./styles/mobileApp.module.scss";

import { ReactComponent as PhoneDown } from "../assets/images/phone_down.svg";
import { ReactComponent as MonitorAirLevels } from "../assets/images/monitor_air_levels.svg";
import { ReactComponent as MonitorAirMask } from "../assets/images/monitor_air_mask.svg";
import { ReactComponent as PollutionGraph } from "../assets/images/pollution_graph.svg";

import PhoneUp from "../assets/images/phone_upwards.svg";
import LightBlueBackground from "../assets/images/light_blue_background.jpg";
import SmokeBackground from "../assets/images/smoke_background.jpg";
import { GlowButton } from "../components";
import { useNavigate } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import Strings from "../strings/strings";

export const MobileAppSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();
  const Carousel = require("react-multi-carousel").default;

  const responsiveCarousel = {
    desktop: {
      breakpoint: { max: 3000, min: 1280 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1280, min: 800 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <div className={styles.carousel}>
        <div id="mobileAppSection" className={styles.titleSection}>
          <span className={styles.title}>
            {Strings.mobileControllOne}
            <br />
            <span className={styles.blueHighligh}>{Strings.mobileControllTwo}</span>
          </span>
          <div className={styles.subtitle}>{Strings.mobileControllSubtitle}</div>
        </div>
        <Carousel
          responsive={responsiveCarousel}
          keyBoardControl={true}
          infinite={true}
          rtl={false}
          slidesToSlide={1}
        >
          <div
            className={styles.longBox}
            style={{ backgroundImage: `url(${LightBlueBackground})` }}
          >
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.mobileApparaTitle}</div>
            </div>
            <div className={styles.longsectionImage}>
              <PhoneDown />
              <div className={styles.sectionImage}>
                <img src={PhoneUp} alt="Phone up" />
              </div>
            </div>
          </div>
          <div className={styles.box} style={{ backgroundImage: `url(${SmokeBackground})` }}>
            <div className={styles.content}>
              <div>
                <div className={styles.boxTitle}>{Strings.mobileMonitorAirTitle}</div>
              </div>
              <div className={styles.imageContent}>
                <div className={styles.oneImage}>
                  <MonitorAirLevels style={{ backdropFilter: "blur(8px)" }} />
                </div>
                <MonitorAirMask style={{ backdropFilter: "blur(8px)" }} />
              </div>
            </div>
          </div>
          <div className={styles.box} style={{ backgroundImage: `url(${LightBlueBackground})` }}>
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.mobileActivitiesTitle}</div>
              <PollutionGraph className={styles.graphImage} />
            </div>
          </div>
        </Carousel>
        <div className={`${styles.underCarouselBox} ${styles.preOrderSection}`}>
          <div className={styles.content}>
            <div className={styles.boxTitleCenter}>{Strings.mobileInterested}</div>
            <div className={styles.buttonCenter}>
              <GlowButton
                text={Strings.mobileInterestedBtn}
                onClick={() => navigate("/products")}
              />
            </div>
          </div>
        </div>
      </div>
      <div {...className}>
        <div className={styles.wrapper}>
          <div id="mobileAppSection" className={styles.titleSection}>
            <span className={styles.title}>
              {Strings.mobileStayControllOne}
              <br />
              <span className={styles.blueHighligh}>{Strings.mobileStayControllTwo}</span>
            </span>
            <div className={styles.subtitle}>{Strings.mobileControllSubtitle}</div>
          </div>
          <div
            className={styles.longBox}
            style={{ backgroundImage: `url(${LightBlueBackground})` }}
          >
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.mobileApparaTitle}</div>
            </div>
            <div className={styles.longsectionImage}>
              <PhoneDown />
              <div className={styles.sectionImage}>
                <img src={PhoneUp} alt="Phone up" />
              </div>
            </div>
          </div>
          <div className={styles.boxContent} style={{ backgroundImage: `url(${SmokeBackground})` }}>
            <div>
              <div className={styles.boxTitle}>{Strings.mobileMonitorAirTitle}</div>
            </div>
            <div className={styles.imageContent}>
              <div className={styles.oneImage}>
                <MonitorAirLevels style={{ backdropFilter: "blur(8px)", width: "100%" }} />
              </div>
              <MonitorAirMask style={{ backdropFilter: "blur(8px)" }} />
            </div>
          </div>
          <div className={styles.box} style={{ backgroundImage: `url(${LightBlueBackground})` }}>
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.mobileActivitiesTitle}</div>
              <PollutionGraph className={styles.graphImage} />
            </div>
          </div>
          <div className={`${styles.box} ${styles.preOrderSection}`}>
            <div className={styles.content}>
              <div className={styles.boxTitleCenter}>{Strings.mobileInterested}</div>
              <div className={styles.buttonCenter}>
                <GlowButton
                  text={Strings.mobileInterestedInApparaBtn}
                  onClick={() => navigate("/products")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
